
import { React, useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import { Box, Grid, Typography } from "@mui/material";
import { colorStore } from "store/ColorsStore";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { TextFieldStyled } from "components/styled/TextField";
import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";
import { _Employee } from "api/CompanyApi/employee";
import Loader from "components/shared/Loader";
import ButtonLoader from "components/shared/ButtonLoader";

let schema = yup.object().shape({
  full_name: yup.string().trim().required("fill name is required"),
  email: yup.string().trim().required("email is required"),
  phone: yup.string().trim().required("phone is required"),
  address: yup.string().trim().required("address is required"),
})

const EmployeeUpdate = ({ id }) => {
  const { t } = useTranslation("index");
  const [editedID, setEditedID] = colorStore((state) => [
    state.editedID,
    state.setEditedID,
  ]);

  const formOptions = { resolver: yupResolver(schema) };
  const { register, handleSubmit, formState } = useForm(formOptions);
  const { errors } = formState;
  const [open, setOpen] = useState(true);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();

  useEffect(() => {
    _Employee.view(editedID).then((res) => {
      setData(res?.employees);
    });
  }, [id, editedID]);

  const details = [
    { head: t("full name"), type: "text", placeholder: t("full_name"), name: "full_name", register: "full_name", error: "full_name", helperText: "full_name", defaultValue: data?.full_name, },
    { head: t('email'), type: "text", placeholder: t("email"), name: "email", register: "email", error: "email", helperText: "email", defaultValue: data?.email, },
    { head: t('phone'), type: "text", placeholder: t("phone"), name: "phone", register: "phone", error: "phone", helperText: "phone", defaultValue: data?.phone, },
    { head: t('address'), type: "text", placeholder: t("address"), name: "address", register: "address", error: "address", helperText: "address", defaultValue: data?.address, },
  ]

  const handleClose = () => {
    setOpen(false);
    setEditedID(null);
  };

  const { mutate } = useMutation((data) => createPost(data))

  async function createPost(data) {
    _Employee.update({
      editedID: editedID,
      formData: data,
    }).catch(err => {
      setLoading(false)
    }).then(() => {
      setLoading(false)
      // handleClose()
    })
  }

  const hanldeUpdate = (input) => {
    const formData = new FormData()
    formData.append("full_name", input.full_name);
    formData.append("email", input.email);
    formData.append("phone", input.phone);
    formData.append("address", input.address);
    formData.append("_method", 'put');

    mutate(formData);
    setLoading(true);
  }

  return (
    <>
      {loading && <Loader />}
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle sx={{ color: "primary.main" }}>{t("Edit Row")}</DialogTitle>
        {!!data && (
          <>
            <Grid container component="form" key={id}>
              {details?.map((item, index) => (
                <Grid key={index} item md={6} sx={{ p: "10px" }}>
                  <Box sx={{ margin: "0 0 8px 5px" }}>
                    <Typography variant="inputTitle">{item.head}</Typography>
                  </Box>
                  <TextFieldStyled
                    sx={{ width: "100%" }}
                    type={item.type}
                    placeholder={item.placeholder}
                    defaultValue={item.defaultValue}
                    name={item.name}
                    {...register(item.register)}
                    error={errors[item.error]?.message}
                    helperText={errors[item.helperText]?.message || ""}
                  />
                </Grid>
              ))}
            </Grid>
          </>
        )}

        <DialogActions>
          <Button onClick={handleClose} sx={{ color: "primary.main" }}>
            {t("Cancel")}
          </Button>
          {loading && <Loader />}

          <ButtonLoader name={t("Submit")}
            onClick={() => handleSubmit(hanldeUpdate)()}
            type="save"
            loading={loading}
            disableOnLoading
          >
            {t("Submit")}
          </ButtonLoader>

        </DialogActions>
      </Dialog>
    </>
  );
};

export default EmployeeUpdate;

